import { useState } from "react";
import { Link } from "react-router-dom";

const faqs = [
  {
    q: "在178漫画网看《家庭教师》需要付费吗？",
    a: "不需要付费。178漫画网提供《家庭教师》等漫画的在线免费阅读服务，所有章节均可直接阅读，无需充值或购买会员。",
  },
  {
    q: "什么是下拉式漫画阅读？",
    a: "下拉式漫画阅读是指漫画图片从上到下连续排列，您只需向下滑动屏幕即可一页页阅读，无需频繁点击翻页按钮，解放双手，浏览体验更加流畅便捷。",
  },
  {
    q: "《家庭教师》漫画多久更新一次？",
    a: "178漫画网会第一时间同步《家庭教师》等热门漫画的最新章节，通常每日更新，您可以在「最近更新」板块查看最新上架的章节。",
  },
  {
    q: "手机上看漫画会卡吗？",
    a: "178漫画网针对移动端做了专门优化，全站漫画均为高清图源并支持流畅加载，在手机、平板、电脑上均可获得顺畅的阅读体验。",
  },
  {
    q: "看漫画需要下载客户端吗？",
    a: "不需要。178漫画网是纯网页阅读平台，打开浏览器即可在线阅读，无需下载任何App或插件，随时随地点开即看。",
  },
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
              <i className="ri-question-line" aria-hidden="true" /> FAQ
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">常见问题解答</h2>
            <p className="mt-3 text-sm leading-7 text-foreground-700">
              关于免费阅读、下拉式漫画、更新频率等问题，这里都有答案。还有疑问？
            </p>
            <Link
              to="/about"
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-bold text-foreground-950 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-customer-service-2-line" aria-hidden="true" />
              联系我们
            </Link>
          </div>

          <div className="lg:col-span-3">
            <div className="flex flex-col gap-3">
              {faqs.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={item.q} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? -1 : index)}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                      aria-expanded={isOpen}
                    >
                      <span className={`text-sm font-semibold md:text-base ${isOpen ? "text-primary-600" : "text-foreground-950"}`}>
                        {item.q}
                      </span>
                      <i
                        className={`shrink-0 text-foreground-500 transition-transform duration-300 ${isOpen ? "rotate-180 text-primary-500" : ""}`}
                        aria-hidden="true"
                      />
                    </button>
                    {isOpen && (
                      <p className="px-5 pb-5 text-sm leading-7 text-foreground-700">{item.a}</p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}